var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.pageType === 'patrol'
        ? 'modal-content-nobg'
        : 'modal-content  modal-content1 myVideo_out'},[_c('video',{staticStyle:{"background":"black","object-fit":"cover"},attrs:{"autoplay":"","controls":"","width":"100%","height":"100%","id":"myVideoAdmine","crossorigin":"*","poster":_vm.posterImg}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }